var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-app-bar',{staticClass:"fixed",attrs:{"dense":"","dark":"","color":_vm.bg}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('title'))+" ")]),_c('v-spacer'),_c('pf-locale',{attrs:{"btn-color":_vm.bg}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }